"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewPageHelmet = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_helmet_1 = require("react-helmet");
/**
 * Link Preview Helmet
 */
function PreviewPageHelmet({ pageTitle, pageDescription, }) {
    return ((0, jsx_runtime_1.jsxs)(react_helmet_1.Helmet, { children: [pageTitle && (0, jsx_runtime_1.jsx)("title", { children: pageTitle }), pageDescription && (0, jsx_runtime_1.jsx)("meta", { name: "description", content: pageDescription }), (0, jsx_runtime_1.jsx)("link", { rel: "icon", href: "data:," }), (0, jsx_runtime_1.jsx)("style", { children: `html {
                height: 100%;
                }
                body {
                font-family: var(--font-primary);
                margin: 0;
                height: 100%;
                }
                #__next, #root {
                height: 100%;
                }` })] }));
}
exports.PreviewPageHelmet = PreviewPageHelmet;
//# sourceMappingURL=PreviewPageHelmet.js.map